<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productWaysOfSales"
    class="m-edition-section-content-subject m-edition-asset-contents"
  >
    <div v-if="nodos.length">
      <h3>
        {{ $t('mEditionAssetActivationCalendar.titles.days') }}
      </h3>
      <blockquote class="quote quote-assets-primary quote-first">
        <p>
          <span v-if="activacion == 1">
            {{ $t('mEditionAssetActivationCalendar.messages.activeOne') }} <b>({{ $utils.formatISODateTime(element.fecha_inicio) }})</b>
          </span>
          <span v-else>
            {{ $t('mEditionAssetActivationCalendar.messages.activeZero') }}
          </span>
        </p>
      </blockquote>

      <p class="margin-top-zero">
        <small class="font-weight-light margin-top-zero">
          <i class="fa fa-info-circle"></i> {{ $t('mEditionAssetActivationCalendar.messages.selectionContent') }}
        </small>
      </p>

      <div class="m-edition-section-content-subject-split-edition">

        <div class="m-edition-section-content-subject-split-edition-item-left">
          <form
            autocomplete="off"
            name="updateProyectoForm"
            @submit.prevent="updateContenidoActivarNodos"
          >
            <div id="containerTree">
              <MoleculeEditionAssetContentsTreeNodeCalendar
                v-for="nodo in nodos"
                :key="nodo.id"
                :contenido="version"
                :element="element"
                :info="{ nodosActivos: Object.assign({}, nodosActivos) }"
                :is-child="false"
                :nodo="nodo"
                node-actions="ActivationCalendar"
                node-actions-class="displayed"
                @event-data="getEventData"
              />
            </div>
            <AtomButtonPrimary
              :button-primary="buttonPrimary.nodo"
              class="margin-top-large"
            />
          </form>
        </div>

        <div class="m-edition-section-content-subject-split-edition-item-right">
          <div class="container">
            <FullCalendar
              class='demo-app-calendar'
              contentHeight="auto"
              defaultView="dayGridMonth"
              :eventAllow="calendar.eventAllow"
              editable="true"
              :events="calendar.events"
              eventLimit= 1
              :eventRender="calendar.eventRender"
              :locale="calendar.config.idioma"
              :header="calendar.config.header"
              height='auto'
              ref="fullCalendar"
              :plugins="calendar.plugins"
              :validRange="calendar.config.validRange"
              :weekends="calendar.weekends"
              :views="calendar.config.views"
              @dateClick="editEntregables"
              @eventClick="deleteEventoCalendar"
              @eventDrop="editDateNodo"
              @eventReceive="eventsAccept"
              @hook:mounted="setCalendarApi"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es'

export default {
  name: 'MoleculeEditionAssetActivationCalendar',

  components: {
    FullCalendar,
    MoleculeEditionAssetContentsTreeNodeCalendar: () => import('@/components/molecules/MoleculeEditionAssetContentsTreeNodeCalendar')
  },

  props: {
    element: Object
  },

  data () {
    return {
      activacion: 0,

      buttonPrimary: {
        nodo: {
          action: 'GUARDAR',
          class: 'a-button-assets-primary',
          sending: false,
          type: 'submit'
        }
      },

      calendar: {
        plugins: [
          dayGridPlugin,
          interactionPlugin
        ],

        weekends: true,
        eventRender (info) {
          info.el.title = info.event.title
        },

        events: [
          {
            id: 'Dateinit',
            title: 'Fecha de Inicio',
            start: this.$utils.formatISODateTime(this.element.fecha_inicio),
            rendering: 'background',
            color: this.$store.getters.getAcademyData.color
          }
        ],

        config: {
          header: {
            left: 'prev',
            center: 'title',
            right: 'next'
          },

          idioma: esLocale,

          views: {
            dayGrid: {
              titleFormat: { month: 'long' }
            }
          },

          validRange: {
            start: this.$utils.formatISODateTime(this.element.fecha_inicio),
            end: this.element.fecha_finalizacion
              ? this.$utils.formatISODateTime(this.element.fecha_finalizacion) + 'T24:00:00'
              : null
          }
        }
      },

      contenidos: [],
      entregablesProyecto: [],

      filters: {
        limite: 1000000
      },

      nodos: [],

      nodosActivos: {
        academia: '',
        nodos: []
      },

      showLoadingState: 0,
      version: 0,
      eventData: [],
      calendarApi: null
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readContenidoEntregables(false)
    }
  },

  created () {
    this.nodosActivos.academia = this.$store.getters.getAcademyData.id
    this.activacion = this.element.fecha_inicio ? 1 : 0
    this.readContenidos()
  },

  methods: {
    changeActivationDay () {
      for (var i in this.calendarApi.getEvents().slice(1)) {
        var index = this.nodosActivos.nodos.findIndex(nodo => nodo.nodo === this.calendarApi.getEvents().slice(1)[i].id)
        this.calendarApi.getEvents().slice(1)[i].start === ''
          ? this.nodosActivos.nodos[index].dia = -1
          : this.nodosActivos.nodos[index].dia = this.parseDate(this.calendarApi.getEvents().slice(1)[i].start)
      }
    },

    deleteEventoCalendar (e) {
      if (e.event.id !== 'Dateinit') {
        this.calendarApi.getEventById(e.event.id).remove()
        let pos = this.nodosActivos.nodos.findIndex(nodo => { return nodo.nodo === e.event.id })
        this.nodosActivos.nodos[pos].dia = -1
      }
    },

    editEntregables (arg) {
      let pos
      var dia = this.parseDate(arg.dateStr)
      pos = this.entregablesProyecto.findIndex(elem => {
        return elem.dia === dia
      })
      if (pos !== -1) {
        this.$modal.showModal('MoleculeEditionAssetSendingOfDeliverablesModalEdit', { version: this.version.id, entregable: this.entregablesProyecto[pos] })
      } else {
        this.$modal.showModal('MoleculeEditionAssetSendingOfDeliverablesModalCreate', { version: this.version.id, dia: dia })
      }
    },

    editDateNodo (e) {
      if (this.nodoChildren(e.event)) {
        e.revert()
        this.$alerts.pushAlert('mEditionAssetActivationCalendar', 'updateContenidoActivarNodos', 'error', 'a-alert-danger')
      } else if (this.nodoPather(e.event)) {
        e.revert()
        this.$alerts.pushAlert('mEditionAssetActivationCalendar', 'updateContenidoActivarNodos', 'error', 'a-alert-danger')
      }
    },

    eventsAccept (arg) {
      let index = this.calendarApi.getEvents().findIndex(evento => {
        return evento.id === arg.event.id
      })

      if (index === (this.calendarApi.getEvents().length - 1)) {
        if (this.nodoChildren(arg.event)) {
          arg.event.remove()
          this.$alerts.pushAlert('mEditionAssetActivationCalendar', 'updateContenidoActivarNodos', 'error', 'a-alert-danger')
        } else if (this.nodoPather(arg.event)) {
          arg.event.remove()
          this.$alerts.pushAlert('mEditionAssetActivationCalendar', 'updateContenidoActivarNodos', 'error', 'a-alert-danger')
        } else {
          arg.event.setProp('backgroundColor', '#FF6F00')
          arg.event.setProp('textColor', '#fff')
        }
      } else {
        this.calendarApi.getEvents()[this.calendarApi.getEvents().length - 1].remove()
      }
    },

    nodoChildren (event) {
      if (event.extendedProps.pather) {
        if (!this.calendarApi.getEvents().find(evento => { return evento.id === event.extendedProps.pather })) {
          return false
        } else if (this.calendarApi.getEvents().find(evento => { return evento.id === event.extendedProps.pather }).start > event.start) {
          return true
        }
      } else {
        return false
      }
    },

    getChildren (children) {
      let array = []
      children.forEach(child => {
        array.push(child.id)
      })
      return array
    },

    getEventData (nodo) {
      this.eventData = nodo
    },

    nodoPather (event) {
      if (event.extendedProps.children.length) {
        for (var i in event.extendedProps.children) {
          if (!this.calendarApi.getEvents().find(evento => { return evento.id === event.extendedProps.children[i] })) {
            i++
          } else if (this.calendarApi.getEvents().find(evento => { return evento.id === event.extendedProps.children[i] }).start < event.start) {
            return true
          }
        }
      } else {
        return false
      }
    },

    parseDate (date) {
      if (date === this.$utils.formatISODateTime(this.element.fecha_inicio)) {
        return 0
      } else {
        let dateNodo = new Date(date).getTime()
        let dateInit = new Date(this.$utils.formatISODateTime(this.element.fecha_inicio)).getTime()
        let diff = dateNodo - dateInit
        diff = Math.round(diff / (1000 * 60 * 60 * 24))
        return diff
      }
    },

    readContenidos () {
      this.$services.read('contenido', 'readContenidos', {}, [this.$route.params.id])
        .then(response => {
          this.contenidos = response.data
          this.version = this.contenidos[0]
          this.readContenidoEntregables(true)
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readContenidoEntregables (write) {
      this.$services.read('contenido', 'readContenidoEntregables', {}, [this.version.id], this.filters)
        .then(response => {
          this.entregablesProyecto = response.data.entregables
          if (write) {
            this.readContenidoNodos()
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.version.id])
        .then(response => {
          this.nodos = response.data
          this.nodos.forEach(nodo => {
            this.setNodosActivos(nodo)
          })
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    setCalendarApi () {
      this.calendarApi = this.$refs.fullCalendar.getApi()
    },

    setNodosActivos (nodo, pather = null) {
      this.nodosActivos.nodos.push({
        nodo: nodo.id,
        dia: -1
      })

      for (let i = 0; i < this.entregablesProyecto.length; i++) {
        if (this.entregablesProyecto[i].tipo === 'nodo' &&
          this.entregablesProyecto[i].nodos.length > 0 &&
          this.entregablesProyecto[i].nodos.find(enodo => enodo.nodo === nodo.id)) {
          this.nodosActivos.nodos[this.nodosActivos.nodos.length - 1].dia = this.entregablesProyecto[i].dia

          this.calendar.events.push({
            id: nodo.id,
            title: nodo.nombre,
            extendedProps: {
              pather: pather,
              children: this.getChildren(nodo.children)
            },
            start: this.nodosActivos.nodos[this.nodosActivos.nodos.length - 1].dia === -1
              ? ''
              : this.$moment.parseZone(this.element.fecha_inicio).add(parseInt(this.nodosActivos.nodos[this.nodosActivos.nodos.length - 1].dia), 'days').format('YYYY-MM-DD'),
            color: '#FF6F00',
            textColor: '#fff'
          })
          break
        }
      }

      if (nodo.children.length > 0) {
        nodo.children.forEach(child => {
          this.setNodosActivos(child, nodo.id)
        })
      }
    },

    updateContenidoActivarNodos () {
      this.changeActivationDay()
      if (!this.buttonPrimary.nodo.sending) {
        this.buttonPrimary.nodo.sending = true
        this.$services.create('contenido', 'updateContenidoActivarNodos', this.nodosActivos, [this.version.id])
          .then(response => {
            this.nodosActivos.nodos = []
            if (this.calendarApi) {
              this.calendarApi.getEvents().forEach(evento => evento.remove())
            }
            this.readContenidoEntregables(true)
            this.calendar.events.splice(1, this.calendar.events.length - 1)
            this.$alerts.pushAlert('mEditionAssetActivationCalendar', 'updateContenidoActivarNodos', 'success')
            this.buttonPrimary.nodo.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetActivationCalendar', 'updateContenidoActivarNodos', 'error', 'a-alert-danger')
            this.buttonPrimary.nodo.sending = false
          })
      }
    }
  }
}

</script>

<style>
  @import '../../../node_modules/@fullcalendar/core/main.css';
  @import '../../../node_modules/@fullcalendar/daygrid/main.css';
</style>
